import { createFileRoute } from "@tanstack/react-router";
import { m } from "~/lib/i18n";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: m.landing_page_meta_title() },
      {
        content: m.landing_page_meta_description(),
        name: "description",
      },
    ],
  }),
});
